module.exports = __webpack_public_path__ + "static/media/ND-JZ.5508b6f6.png";